<template>
  <div class="wallet-listing">
  <v-row class="mt-0">
    <v-col cols="12" lg="4" v-for="(bank, index) in banks" :key="bank.id">
      <v-card
        class="elevation-0 rounded-0 transition-method-card bank-account-card"
        :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
      >
        <v-card-actions class="paymentImage align-center justify-center">
          <span class="wallet-method-icon"><v-icon>mdi-bank</v-icon></span>
          <h3>{{ bank.bank_name }}</h3>
        </v-card-actions>
        <v-card-actions class="content">
          <div class="value">
            <span>Bank Name</span>
            <span>{{ bank.bank_name }}</span>
          </div>
          <v-spacer></v-spacer>
          <div class="value">
            <span>Account No.</span>
            <span>{{ bank.bank_acc_num }}</span>
          </div>
        </v-card-actions>

        <v-card-actions class="button-details">
          <v-dialog
            v-model="dialogVisibility[index]"
            transition="scale-transition"
            origin="center center"
            max-width="695"
            content-class="deposit-withdraw-popup bank-transfer-details-popup"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                tile
                outlined
                elevation="0"
                class="text-capitalize btn-account"
                color="greenMain"
                v-bind="attrs"
                v-on="on"
              >Details</v-btn>
            </template>
            <template v-slot:default="{ dialog }">
              <v-card
                class="rounded-0"
                :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'"
              >
                <v-btn class="close" icon @click="dialogVisibility[index] = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="rounded-0 mb-5">Bank Transfer Detail</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Brokers Bank Name</span>
                      <p class="text-left">{{ bank.bank_name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Bank Country</span>
                      <p class="text-sm-right text-left">{{ bank.bankcountries?.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Account Name</span>
                      <p class="text-left">{{ bank.bank_acc_name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">City</span>
                      <p class="text-sm-right text-left">{{ bank.bankcities?.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Account Number</span>
                      <p class="text-left">{{ bank.bank_acc_num }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">State / Province / Division</span>
                      <p class="text-sm-right text-left">{{ bank.bankstates?.name }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">IFSC Code</span>
                      <p class="text-left">{{ bank.ifsc_code }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Postal Code</span>
                      <p class="text-sm-right text-left">{{ bank.bank_postal_code }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="d-block mb-2">Bank IBAN Number</span>
                      <p class="text-left">{{ bank.bank_iban_num }}</p>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span class="text-sm-right d-block mb-2">Bank Address</span>
                      <p class="text-sm-right text-left">{{ bank.bank_address }}</p>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
  <div class="wallet-information-footer" v-if="banks.length">
    <span>Showing 1 to {{ banks.length }} of {{ banks.length }} entries</span>
    <span><v-icon small>mdi-chevron-left</v-icon> 1 <v-icon small>mdi-chevron-right</v-icon></span>
  </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { BANK__ACTIONS } from "@/store/action-types";

export default {
  name: 'BankListing',
  
  data() {
    return {
      dialogVisibility: {},
    };
  },

  computed: {
    ...mapState("bank", ["banks"]),
  },

  methods: {
    ...mapActions("bank", [BANK__ACTIONS.GETALL]),

    initializeDialogVisibility() {
      this.banks.forEach((_, index) => {
        this.$set(this.dialogVisibility, index, false);
      });
    },
  },

  async mounted() {
    await this[BANK__ACTIONS.GETALL]();
    this.initializeDialogVisibility();
  },

  watch: {
    banks: {
      handler() {
        this.initializeDialogVisibility();
      },
      immediate: true,
    },
  },
};
</script>
